<template>
  <v-row align="center" justify="center">
    <v-col cols="12" xs="12" sm="8" md="6" lg="5" xl="4" class="text-center">
      <v-card color="transparent" elevation="0" v-if="!identitySelect">
        <v-card-title class="flex-column justify-center">
          <span class="display-3 mb-1">寵物健檢雲平台</span>
        </v-card-title>
        <v-card-text>
          <v-card outlined class="pt-3">
            <v-card-text>
              <v-form ref="form">
                <v-text-field
                  @keyup.enter="authenticate"
                  v-model="phone"
                  label="帳號"
                  :rules="phoneRules"
                  required
                  outlined
                />
                <v-text-field
                  @keyup.enter="authenticate"
                  v-model="password"
                  label="密碼"
                  :rules="passwordRules"
                  required
                  outlined
                  :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  @click:append="showPassword = !showPassword"
                  :type="showPassword ? 'text' : 'password'"
                />
              </v-form>
              <div class="red--text pb-2" v-if="showError">帳號或密碼錯誤</div>
              <v-btn color="cyan white--text" block large depressed @click="authenticate">登入</v-btn>
            </v-card-text>
          </v-card>
        </v-card-text>
      </v-card>

      <v-card color="transparent" elevation="0" v-else>
        <v-card-title class="flex-column justify-center">
          <span class="display-3 mb-1">請選擇登入身份</span>
        </v-card-title>
        <v-card-text>
          <v-card outlined>
            <v-list class="py-0 cross-row">
              <template v-for="(identity, index) in authIdentify">
                <v-list-item
                  :key="index"
                  v-ripple
                  @click="radios=index"
                  :color="$classStyle.mainColor"
                  :input-value="radios===index"
                >
                  <v-list-item-icon class="mr-0">
                    <v-radio-group v-model="radios" hide-details dense class="mt-0">
                      <v-radio :key="index" :value="index" :color="$classStyle.mainColor"></v-radio>
                    </v-radio-group>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="text-left">{{identity.clinicName}}</v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-action>{{$common.parsePermission(identity.permission)}}</v-list-item-action>
                </v-list-item>
                <v-divider v-if="index < authIdentify.length" :key="`${index}-divider`"></v-divider>
              </template>
            </v-list>

            <v-card-text class="d-flex justify-space-between">
              <v-btn large depressed @click="back">重新登入</v-btn>
              <v-btn color="cyan white--text" large depressed @click="confirmIdentity">確定</v-btn>
            </v-card-text>
          </v-card>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>
<style scoped></style>
<script>
export default {
  data: () => ({
    identitySelect: false,
    phone: "",
    password: "",
    phoneRules: [v => !!v || "請輸入電話號碼"],
    passwordRules: [v => !!v || "請輸入密碼"],
    showPassword: false,
    showError: false,
    authIdentify: [],
    radios: 0
  }),
  methods: {
    back() {
      this.phone = "";
      this.password = "";

      this.identitySelect = false;
    },
    async authenticate() {
      if (this.$refs.form.validate()) {
        try {
          let response = await this.$ajax.post(`${this.$config.apiUrl}/login`, {
            phone: this.phone,
            password: this.password
          });
          if (response.data !== null) {
            // localStorage.setItem("authAccount", JSON.stringify(response.data));
            // this.$router.push("/");
            this.authIdentify = response.data;
            if (this.authIdentify.length > 1) {
              this.identitySelect = true;
            } else {
              this.confirmIdentity();
            }
          } else {
            this.showError = true;
          }
        } catch (e) {
          console.error(e);
          this.showError = true;
        }

        // if (this.account === "admin") {
        //   localStorage.setItem(
        //     "authAccount",
        //     JSON.stringify({
        //       name: "admin",
        //       role: "admin"
        //     })
        //   );
        // } else if (this.account === "employee") {
        //   localStorage.setItem(
        //     "authAccount",
        //     JSON.stringify({
        //       name: "employee",
        //       role: "employee"
        //     })
        //   );
        // } else {
        //   localStorage.setItem(
        //     "authAccount",
        //     JSON.stringify({
        //       name: "superAdmin",
        //       role: "superAdmin"
        //     })
        //   );
        // }
        // this.$router.push("/");
      }
    },
    confirmIdentity() {
      localStorage.setItem(
        "authAccount",
        JSON.stringify(this.authIdentify[this.radios])
      );
      this.$router.push("/");
    }
  }
};
</script>

